export default __webpack_public_path__ + "static/media/redblu.9a1aa51e.png";